<template lang="pug">
  div(class="container-xl px-0 gallery-2 py-3")
    swiper(:options="swiperOptions" ref="mySwiper" class="mt-2")
      swiper-slide(v-for="image in $parent.gallery")
        div.w-100
          img(:src="image" :key="image" class="img-fluid swiper-lazy")
        //- .swiper-lazy-preloader.swiper-lazy-preloader-white
      .swiper-button-prev(slot="button-prev")
      .swiper-button-next(slot="button-next")

    .row.mb-0.mt-4
      div(class="col-12 col-md-6")
        <iframe width="100%" height="250" src="https://www.youtube.com/embed/ND3y8vjA0K4" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      div(class="col-12 col-md-6")
        <iframe width="100%" height="250" src="https://www.youtube.com/embed/JzmQvbzLMl8" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  components: {
    swiper,
    swiperSlide
  },
  data: () => ({
    swiperOptions: {
      autoHeight: true,
      // lazy: true,
      loop: true,
      autoplay: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
        clickable: true,
      },

    }
  })
}
</script>

<style scoped>
.gallery-2 .swiper-slide {
  text-align: center;
}

.gallery-2 img {
  max-height: 600px;
  margin: auto;
}
</style>